import { withBrowserContext } from '../../../utils/localizationContext/withBrowserContext';
import { fileSizeFormat as fileSizeFormatBase } from '../../../utils/formatters/fileSize';

export const fileSizeFormat = withBrowserContext(fileSizeFormatBase);
